import type {PreviewPrepare} from '../types'

export const text = (title: string): PreviewPrepare => ({
  prepare: () => ({
    title,
  }),
})
